/* eslint-disable import/prefer-default-export */
import sortBy from 'lodash/sortBy';

export function sortContacts(contacts) {
  const sortedByLastSeen = sortBy(contacts, ['last_seen']).reverse();

  return sortBy(sortedByLastSeen, ['is_online', 'is_mobile_online', 'unseen_messages']).reverse();
}
